<template>
  <div class="ticket-chat d-flex flex-column" style="height: 100%">
    <!-- Lista de mensagens -->
    <div
      class="chat-messages flex-grow-1 overflow-y-auto pa-4"
      ref="messageList"
    >
      <div v-if="!interacoes.length" class="text-center grey--text pa-8">
        <v-icon color="grey lighten-1" size="48">mdi-chat-outline</v-icon>
        <p class="mt-3">Nenhuma interação disponível ainda.</p>
      </div>
      <div
        v-for="(interacao, index) in interacoes"
        :key="index"
        class="mb-4"
        :class="ehCliente(interacao) ? 'd-flex flex-row-reverse' : 'd-flex'"
      >
        <!-- Avatar -->
        <v-avatar
          size="36"
          :color="ehCliente(interacao) ? 'primary' : 'secondary'"
          class="flex-shrink-0"
          :class="ehCliente(interacao) ? 'ml-2' : 'mr-2'"
        >
            <v-icon v-if="ehCliente(interacao)" color="white">mdi-account</v-icon>
            
            <v-img
              v-else
              style="width: 80%;"
              src="@/assets/gali-folha.png"
            />
        </v-avatar>

        <!-- Balão de mensagem -->
        <div style="max-width: 75%">
          <!-- Nome + data -->
          <div
            class="caption grey--text mb-1"
            :class="ehCliente(interacao) ? 'text-right' : 'text-left'"
          >
            <strong>{{ isProgali || ehCliente(interacao) ? nomeUsuario(interacao.usuario): 'Equipe Gali' }}</strong>
            &nbsp;·&nbsp;{{ formatarData(interacao.data) }}
          </div>
          <!-- Arquivos -->
          <div
            v-if="interacao.arquivos && interacao.arquivos.length"
            class="mt-2"
          >
            <lista-arquivos-interacao
              :arquivos="interacao.arquivos"
              :ticket-id="ticketId"
            />
          </div>

          <!-- Texto -->
          <v-card
            flat
            :class="
              ehCliente(interacao)
                ? 'chat-bubble-client'
                : 'chat-bubble-support'
            "
            class="pa-3 rounded-lg"
            style="word-break: break-word; white-space: pre-wrap"
          >
            {{ interacao.descricao }}
          </v-card>
        </div>
      </div>
    </div>

    <v-divider />

    <!-- Input de nova mensagem -->
    <div class="chat-input pa-3" v-if="!foiFinalizado">
      <v-row align="center" no-gutters>
        <v-col>
          <v-textarea
            v-model="novaMensagem"
            placeholder="Escreva sua mensagem..."
            outlined
            dense
            hide-details
            rows="2"
            auto-grow
            class="chat-textarea"
            :disabled="enviando"
          />
        </v-col>
        <v-col cols="auto" class="d-flex flex-column ml-2">
          <v-btn
            icon
            @click="$refs.fileInput.click()"
            :disabled="enviando"
            class="mb-1"
            title="Anexar arquivo"
          >
            <v-icon color="grey darken-1">mdi-paperclip</v-icon>
          </v-btn>
          <v-btn
            icon
            color="secondary"
            @click="enviarMensagem"
            :loading="enviando"
            :disabled="!novaMensagem.trim()"
            title="Enviar"
          >
            <v-icon>mdi-send</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <!-- Arquivos selecionados -->
      <div v-if="arquivosSelecionados.length" class="mt-2">
        <v-chip
          v-for="(f, i) in arquivosSelecionados"
          :key="i"
          small
          close
          class="mr-1 mb-1"
          @click:close="arquivosSelecionados.splice(i, 1)"
        >
          <v-icon small left>mdi-file</v-icon>
          {{ f.name }}
        </v-chip>
      </div>
      <input
        type="file"
        ref="fileInput"
        multiple
        hidden
        @change="selecionarArquivos"
      />
    </div>
    <div v-else class="pa-3 text-center grey--text">
      
        Este ticket foi finalizado. Não é possível enviar novas mensagens.
    </div>

    <!-- Snackbar feedback -->
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :timeout="4000"
      bottom
    >
      {{ snackbarMsg }}
      <template v-slot:action>
        <v-btn text icon @click="snackbar = false"
          ><v-icon>mdi-close</v-icon></v-btn
        >
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import API from "@/api/API";
import ListaArquivosInteracao from "./ListaArquivosInteracao.vue";

export default {
  name: "TicketChat",
  components: {
    ListaArquivosInteracao,
  },
  props: {
    ticket: {
      type: Object,
      required: true,
    },
    ticketId: {
      type: [String, Number],
      required: true,
    },
    isProgali: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    novaMensagem: "",
    arquivosSelecionados: [],
    interacoes: [],
    enviando: false,
    snackbar: false,
    snackbarMsg: "",
    snackbarColor: "success",
  }),
  computed: {
    foiFinalizado() {
      return this.ticket.status == 'Concluído' || this.ticket.id.includes('FINALIZADO_');
    },
  },
  // watch: {
  //   interacoes() {
  //     this.$nextTick(this.scrollToBottom);
  //   },
  // },
  async mounted() {
    await this.buscaInteracoes();
    this.scrollToBottom();
  },
  methods: {
    async buscaInteracoes() {
      const interacoesInternas =
        this.ticket.historicoInteracoes?.filter((i) => !i.isInterno) || [];
      const interacoesApi = await API.buscarInteracoesTicket(this.ticketId);
      console.log("Interações do ticket:", interacoesApi);
      this.interacoes = [...interacoesInternas, ...interacoesApi];
    },
    ehCliente(interacao) {
      if (this.isProgali) {
        return !interacao.isCliente;
      }
      return interacao.isCliente;
    },
    nomeUsuario(usuarioStr) {
      try {
        const u =
          typeof usuarioStr === "string" ? JSON.parse(usuarioStr) : usuarioStr;
        return u?.mail || "Usuário";
      } catch {
        return "Usuário";
      }
    },
    iniciais(usuarioStr) {
      const nome = this.nomeUsuario(usuarioStr);
      return nome
        .split(" ")
        .slice(0, 2)
        .map((n) => n[0])
        .join("")
        .toUpperCase();
    },
    formatarData(data) {
      if (!data) return "";
      return new Date(data).toLocaleString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    scrollToBottom() {
      const el = this.$refs.messageList;
      if (el) el.scrollTop = el.scrollHeight;
    },
    selecionarArquivos(e) {
      this.arquivosSelecionados = [
        ...this.arquivosSelecionados,
        ...e.target.files,
      ];
      this.$refs.fileInput.value = "";
    },
    formatarNome(emailGali) {
      return emailGali
        .split("@")[0]
        .split(".")
        .map((parte) => parte.charAt(0).toUpperCase() + parte.slice(1))
        .join(" ");
    },
    async enviarMensagem() {
      try {
        if (!this.novaMensagem.trim()) return;
        this.enviando = true;
        const emailUsuario =
          sessionStorage.getItem("emailUsuario") ||
          "progali@galienergia.com.br";
        const novaInteracao = {
          data: new Date().toISOString(),
          descricao: this.novaMensagem.trim(),
          isInterno: false,
          usuario: JSON.stringify({
            displayName: emailUsuario.includes("@galienergia.com.br")
              ? this.formatarNome(emailUsuario)
              : "Cliente",
            mail: emailUsuario,
          }),
        };
        await API.adicionarInteracaoPortal(
          this.ticket,
          novaInteracao,
          this.arquivosSelecionados,
        );
        await this.buscaInteracoes();
        // Optimistic update
        this.novaMensagem = "";
        this.arquivosSelecionados = [];
        this.snackbarMsg = "Mensagem enviada com sucesso!";
        this.snackbarColor = "success";
        this.snackbar = true;
        this.$emit("nova-interacao");
        this.$nextTick(this.scrollToBottom);
      } catch (e) {
        this.snackbarMsg = "Erro ao enviar mensagem. Tente novamente.";
        this.snackbarColor = "error";
        this.snackbar = true;
      } finally {
        this.enviando = false;
      }
    },
  },
};
</script>

<style scoped>
.ticket-chat {
  height: 100%;
}
.chat-messages {
  background-color: #fafafa;
}
.chat-bubble-client {
  background-color: #f3e8ff !important;
  border: 1px solid #d8b4fe;
  color: #1a0040;
}
.chat-bubble-support {
  background-color: #f1f5f9 !important;
  border: 1px solid #e2e8f0;
  color: #1e293b;
}
.chat-textarea >>> .v-input__slot {
  border-radius: 12px !important;
}
</style>
